import type { Country } from '@/shared/types';

export function countriesFilter(country: Country, value: string) {
  const search = value.trim().toLowerCase();

  return (
    country.name.toLowerCase().includes(search) ||
    country.code.toLowerCase().includes(search) ||
    country.phoneCode.toLowerCase().includes(search)
  );
}
